import React from 'react';
import { ReelSection } from './ReelSection';
import './MainView.css';
import VideoCarousel from '../Shared/VideoCarousel';
import Services from './Services';

export const MainView = () => {
	// Recent works data for the main page
	const recentWorksVideos = [
		{
			type: 'youtube',
			youtubeId: 'K5sgTJoQHXA',
			title: 'Out My Mind by LECARDIEAY (2026)',
			details: 'Editor',
			thumbnail: 'images/thumbnails/placeholder.svg',
		},
		{
			type: 'youtube',
			youtubeId: '4FD4zc5hhYc',
			title: 'FRIENDSTOENEMIES by TreTheDon (2025)',
			details: 'Editor',
			thumbnail: 'images/thumbnails/placeholder.svg',
		},
		{
			type: 'youtube',
			youtubeId: 'Uo1Pdh9-Psc',
			title: 'Tell Me by LECARDIEAY (2025)',
			details: 'Editor',
			thumbnail: 'images/thumbnails/placeholder.svg',
		},
		{
			type: 'youtube',
			youtubeId: '7muuRD4gkWw',
			title: 'Photophobia (2025)',
			details: '1st Assistant Camera',
			thumbnail: 'images/thumbnails/Photophobia-Thumbnail-Option-1.png',
		},
	];

	return (
		<div className='main-page'>
			<ReelSection />
			<VideoCarousel
				title='Recent works'
				videos={recentWorksVideos}
				sectionId='recent-works'
			/>
			<Services />
		</div>
	);
};
